import { ASSETS_TYPES } from '@modules/consolidator/constants/Assets'

export const collectOrphanCustomAssets = (walletAnalysis) => {
  const seenIds = []
  const orphans = []
  for (const grupo of readGrupos(walletAnalysis)) {
    for (const orphan of collectGroupOrphans(grupo)) {
      if (seenIds.includes(orphan.id)) continue
      seenIds.push(orphan.id)
      orphans.push(orphan)
    }
  }
  return orphans
}

const collectGroupOrphans = (grupo) => {
  const ativos = grupo && Array.isArray(grupo.ativos) ? grupo.ativos : []
  const orphans = []
  for (const ativo of ativos) {
    const orphan = buildOrphanEntry(ativo, grupo)
    if (orphan) orphans.push(orphan)
  }
  return orphans
}

const buildOrphanEntry = (ativo, grupo) => {
  if (!isOrphanCustomAsset(ativo)) return null
  const nome = resolveAssetName(ativo)
  const id = resolveAssetId(ativo)
  if (!nome || !id) return null
  return {
    id,
    id_conta: ativo.id_conta || null,
    nome_ativo: nome,
    grupo: (grupo && grupo.grupo) || '',
  }
}

export const isOrphanCustomAsset = (asset) => {
  if (!asset) return false
  const tipo = asset['Tipo'] || asset.tipo || ''
  const idAtivo = asset.id_ativo
  const hasBaseLink =
    idAtivo !== null && idAtivo !== undefined && idAtivo !== ''
  return tipo === ASSETS_TYPES.PERSONALIZADO && !hasBaseLink
}

export const buildOrphanCustomAssetMessage = (asset) => {
  const nome = resolveAssetName(asset)
  if (!nome) return ''
  return `O ativo personalizado "${nome}" não está vinculado à base do escritório — ele existe apenas neste cliente. Vincule à base para padronizar a série e a precificação no escritório.`
}

const readGrupos = (walletAnalysis) => {
  if (!walletAnalysis || !walletAnalysis.posicao_completa) return []
  const grupos = walletAnalysis.posicao_completa.grupos
  return Array.isArray(grupos) ? grupos : []
}

const resolveAssetId = (asset) => (asset && asset.id) || null

const resolveAssetName = (asset) =>
  String((asset && asset.nome_ativo) || '').trim()
